import React from 'react'

const InnovativeSuccess = ({service}) => {
  return (
    <div>
           <div className="row">
          {service.map((val, i) => (
            <div
              className="col-lg-3 col-md-6  md-border-none border-end border-top text-center"
              key={i}
            >
              <div className="p-3 h-50   pb-4" >
                <img
                  src={val.icon}
                  alt=""
                  className=" mb-md-4 mb-2"
                  style={{ width: 50,height:50 }}
                />
                <h3 className=" h3-heading lh-base text-white fw-semibold mt-2" >
                  {val.title}
                </h3>
                <p className="h3-para lh-base  text-white mt-2 fs-6 " style={{opacity:'60%'}}>{val.desc}</p>
              </div>
              <div className="p-3 md-border-none h-50">
                <img
                  src={val.icon2}
                  alt=""
                  className=" mb-md-4 mb-2"
                  style={{ width: 50,height:50 }}
                />
                <h3 className="h3-heading  text-white  fw-semibold mt-2" style={{fontSize:19}}> 
                  {val.title2}
                </h3>
                <p className="h3-para lh-base text-white  mt-2 fs-6" style={{opacity:'60%'}}>{val.desc2}</p>
              </div>
            </div>
          ))}
        </div>
    </div>
  )
}

export default InnovativeSuccess